.wrapper {
  display: flex;
  flex-direction: column;
}

.form {
  display: flex;
  gap: 8px;
  align-items: center;
}

.button {
  white-space: nowrap;
  flex-shrink: 0;
}

.clearButton {
  background: none;
  color: var(--gray-text);
  border: 1px solid var(--gray-border);
  white-space: nowrap;
  flex-shrink: 0;
}

.clearButton:hover:not(:disabled) {
  color: var(--text);
  border-color: var(--gray-text);
}

.hint {
  margin: 3px 0 0;
  font-size: 0.7rem;
  color: var(--gray-text);
  text-align: center;
}
